<template>
    <div class="ins-content">
        <!-- Thông tin bài tập -->
        <div class="info-strip" v-if="infoText">
            <span class="dot"></span>{{ infoText }}
        </div>

        <!-- Đề bài -->
        <div class="section-card">
            <div class="section-head">Đề bài</div>
            <div class="section-body callout">
                {{ detail && detail?.groupquestion?.description }}
            </div>
        </div>

        <!-- Bài làm -->
        <div class="section-card">
            <div class="section-head">
                Bài làm
                <span v-if="gradedAt" class="right meta-text">
                    Thời gian chấm: {{ gradedAt }}
                </span>
            </div>
            <!-- Writing -->
            <div v-if="typeGroupQuestion == 'Writing'" class="section-body answer pre-wrap">
                {{ detail && detail.answer }}
            </div>

            <!-- Speaking -->
            <div v-if="typeGroupQuestion == 'Speaking'" class="section-body answer pre-wrap">
                <audio controls preload="metadata" ref="video-log">
                    <source :src="detail.answer" type="audio/ogg">
                </audio>
            </div>
            <div v-if="typeGroupQuestion == 'Writing'" class="section-foot">
                <span class="meta-text">Số từ: {{ wordCount }}</span>
            </div>
        </div>

        <!-- Danh sách nhận xét -->
        <div class="section-card">
            <div class="section-head">
                Danh sách nhận xét
            </div>
            <!-- Writing -->
            <div v-if="typeGroupQuestion == 'Writing'" class="section-body">
                <ol class="comment-list">
                    <li v-for="(c, i) in writingCommentItems || []" :key="i" class="comment-item">
                        <div class="num">{{ i + 1 }}.</div>
                        <div class="comment-content">
                            <div class="line"><span class="hl" v-html="c.textHtml"></span></div>
                            <div v-if="c.feedback" class="hint" v-html="c.feedbackHtml"></div>
                        </div>
                    </li>
                </ol>
            </div>
            <!-- Speaking -->
            <div v-if="typeGroupQuestion == 'Speaking'" class="section-body">
                <ol class="comment-list">
                    <li v-for="(c, i) in commentItems || []" :key="i" class="comment-item">
                        <div class="num">{{ i + 1 }}.</div>
                        <div class="comment-content">
                            <div class="line"><span>{{ c.label }}</span></div>
                            <div v-if="c.text" class="hint" v-html="c.text"></div>
                        </div>
                    </li>
                </ol>
            </div>
        </div>

        <!-- Điểm  Writing-->
        <div v-if="typeGroupQuestion == 'Writing'" class="section-card">
            <div class="section-head">Điểm</div>

            <div class="score-input-grid">
                <div class="score-field">
                    <div class="field-label">Task Achievement</div>
                    <el-input class="score-input" :value="score('task-achievement')" size="small" readonly />
                </div>

                <div class="score-field">
                    <div class="field-label">Coherence & Cohesion</div>
                    <el-input class="score-input" :value="score('coherence-and-cohesion')" size="small" readonly />
                </div>

                <div class="score-field">
                    <div class="field-label">Lexical Resource</div>
                    <el-input class="score-input" :value="score('lexical-resource')" size="small" readonly />
                </div>

                <div class="score-field">
                    <div class="field-label">Grammar Range & Accuracy</div>
                    <el-input class="score-input" :value="score('grammatical-range-and-accuracy')" size="small"
                        readonly />
                </div>

                <div class="score-field overall">
                    <div class="field-label">Overall</div>
                    <el-input class="score-input score-input--overall" :value="score('overall')" size="small"
                        readonly />
                </div>
            </div>
        </div>

        <!-- Điểm Speaking -->
        <div v-if="typeGroupQuestion == 'Speaking'" class="section-card">
            <div class="section-head">Điểm</div>

            <div class="score-input-grid">
                <div class="score-field">
                    <div class="field-label">Fluency</div>
                    <el-input class="score-input" :value="score('fluency')" size="small" readonly />
                </div>

                <div class="score-field">
                    <div class="field-label">Pronunciation</div>
                    <el-input class="score-input" :value="score('pronunciation')" size="small" readonly />
                </div>

                <div class="score-field">
                    <div class="field-label">Vocabulary Range</div>
                    <el-input class="score-input" :value="score('vocabularyRange')" size="small" readonly />
                </div>

                <div class="score-field">
                    <div class="field-label">Grammatical Range</div>
                    <el-input class="score-input" :value="score('grammaticalRange')" size="small" readonly />
                </div>

                <div class="score-field overall">
                    <div class="field-label">Overall</div>
                    <el-input class="score-input score-input--overall" :value="score('overall')" size="small"
                        readonly />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
const LABEL_MAP = {
  fluency: 'Fluency & Coherence',
  vocabularyRange: 'Lexical Resource',
  grammaticalRange: 'Grammatical range & Accuracy',
  pronunciation: 'Pronunciation'
};
export default {
    name: 'InspectionContent',
    props: { detail: { type: Object, default: null } },
    computed: {
        typeGroupQuestion() {
            return this.detail && this.detail.exercise_format;
        },
        commentItems() {
            console.log(this.detail,'detail');
            
            let raw = (this.detail && this.detail.comments) || [];
            
            // Nếu comments là string (JSON), parse thành array
            if (typeof raw === 'string') {
                try {
                    raw = JSON.parse(raw);
                } catch (e) {
                    console.error('Error parsing comments JSON:', e);
                    raw = [];
                }
            }
            
            // Đảm bảo raw là array
            if (!Array.isArray(raw)) {
                raw = [];
            }
            
            return raw.flatMap(obj => {
                if (!obj || typeof obj !== 'object') return [];
                const key = Object.keys(obj)[0];
                if (!key) return [];
                const text = obj[key] == null ? '' : String(obj[key]);
                const textHtml = this.nl2br(text);
                return [{
                    label: LABEL_MAP[key] || key,
                    text: textHtml
                }];
            });
        },
        writingCommentItems() {
            let arr = (this.detail && this.detail.comments) || [];
            
            // Nếu comments là string (JSON), parse thành array
            if (typeof arr === 'string') {
                try {
                    arr = JSON.parse(arr);
                } catch (e) {
                    console.error('Error parsing comments JSON:', e);
                    arr = [];
                }
            }
            
            // Đảm bảo arr là array
            if (!Array.isArray(arr)) {
                arr = [];
            }
            
            return arr.map(c => ({
                ...c,
                textHtml: this.nl2br(String(c && c.text != null ? c.text : '')),
                feedbackHtml: this.nl2br(String(c && c.feedback != null ? c.feedback : ''))
            }));
        },
        infoText() {
            if (!this.detail) return '';
            const c = this.detail.course_name || 'Khóa';
            const s = this.detail.student_name || 'Học viên';
            const buoi = this.detail.lesson_id || 'Buổi';
            const q = this.detail.sentence || 'Câu';
            return `Thông tin bài tập: Khóa ${c} - ${s} - Buổi ${buoi} - Câu ${q}`;
        },
        gradedAt() {
            const ts = this.detail && this.detail.updated_at_overall;
            if (!ts) return '';

            const m = moment(ts);
            return m.isValid() ? m.format('HH:mm:ss DD-MM-YYYY') : '';
        },
        wordCount() {
            if (!this.detail || !this.detail.answer) return 0;
            return (this.detail.answer.match(/[A-Za-zÀ-ỹ0-9]+/g) || []).length;
        },
        commentsCount() {
            return ((this.detail && this.detail.teacher_comments) || []).length;
        },
        commentsTotal() {
            return this.detail && this.detail.teacher_comments_total
                ? this.detail.teacher_comments_total
                : this.commentsCount;
        }
    },
    methods: {
        nl2br(input) {
            const raw = input == null ? '' : String(input);
            const escaped = raw
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
            return escaped
                .replace(/\t/g, '    ')
                .replace(/  /g, ' &nbsp;')
                .replace(/\r?\n/g, '<br/>')
                .replace(/\\n/g, '<br/>');
        },
        getAudioByField(string) {
            let url = string.split("://");
            if (url.length > 1) {
                return string;
            }
            return "https://" + string
        },
        score(key) {
            if (key == 'overall') {
                return (this.detail && this.detail.score) || '-';
            }
            
            let scoreDetail = this.detail && this.detail.score_detail;
            
            // Nếu score_detail là string (JSON), parse thành object
            if (typeof scoreDetail === 'string') {
                try {
                    scoreDetail = JSON.parse(scoreDetail);
                } catch (e) {
                    console.error('Error parsing score_detail JSON:', e);
                    scoreDetail = {};
                }
            }
            
            return (scoreDetail && scoreDetail[key]) || '-';
        }
    }
};
</script>

<style scoped>
.section-card {
    background: #fff;
    border: 1px solid #e9edf3;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 12px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, .03);
}

.section-head {
    font-weight: 600;
    margin-bottom: 8px;
    position: relative
}

.section-head .right {
    float: right;
    font-style: italic;
}

.section-foot {
    margin-top: 6px;
    text-align: right
}

.pre-wrap {
    white-space: pre-wrap
}

.info-strip {
    background: #f8f5ff;
    border: 1px solid #ece4ff;
    color: #53389e;
    padding: 8px 12px;
    border-radius: 8px;
    margin-bottom: 10px;
    font-size: 13px
}

.info-strip .dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #7c3aed;
    margin-right: 6px
}

.meta-text {
    color: #6f42c1;
    font-weight: 600
}

.callout {
    background: #f4f7ff;
    border: 1px solid #e5ecff;
    border-radius: 8px;
    padding: 12px
}

.counter {
    margin-left: 8px;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 999px
}

.success {
    background: #eafaf0;
    color: #067647;
    border: 1px solid #a6f0c6
}

.comment-list {
    list-style: none;
    padding-left: 0;
    margin: 0
}

.comment-item {
    display: flex;
    align-items: flex-start;
    background: #fff;
    border: 1px solid #eceff4;
    border-radius: 8px;
    padding: 8px 10px;
    margin-bottom: 8px
}

.comment-item .num {
    font-weight: 700;
    color: #475467;
    margin-right: 8px
}

.comment-content .hl {
    background: #fff6a1;
    border-radius: 3px;
    padding: 0 3px;
    font-weight: 600
}

.comment-content .hint {
    color: #98a2b3;
    font-size: 13px
}

.score-input-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
}

.field-label {
    --lh: 1.2;
    line-height: var(--lh);
    font-size: 12px;
    color: #8a94a6;
    margin-bottom: 6px;
    min-height: auto;
    max-height: none;
    overflow: visible;
    display: block;
    word-break: break-word;
}

@media (max-width: 767.98px) {
    .field-label {
        min-height: calc(var(--lh) * 2em);
        max-height: calc(var(--lh) * 2em);
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
}

.score-input>>>.el-input__inner,
.score-input /deep/ .el-input__inner {
    background: #f7f9fc;
    border: 1px solid #e7edf6;
    border-radius: 10px;
    /* bớt bo tròn */
    height: 50px;
    text-align: center;
    font-size: 15px;
    font-weight: 600;
    color: #0f172a;
    box-shadow: none;
}

.score-input>>>.el-input__inner:focus,
.score-input /deep/ .el-input__inner:focus {
    border-color: #e7edf6;
    box-shadow: none;
}

.score-field.overall .field-label {
    color: #6f42c1;
    font-weight: 600;
}

.score-input--overall>>>.el-input__inner,
.score-input--overall /deep/ .el-input__inner {
    background: #f3e8ff;
    border-color: #e3d7ff;
    color: #111827;
    border-radius: 10px;
}
</style>